export default __webpack_public_path__ + "bml-video407d76.png";